export const PUBLIC_OFFERS_TYPE = 'public-offers';
export const DERBYSOFT_TYPE = 'derbysoft';
